<span
    class="h6"
    role="heading"
    aria-level="2"
    >{{ i18n._939_EMAIL_RECOVERY | translate }}</span
>
<p>
    {{
        i18n._940_ENTER_YOUR_EMAIL_IN_THE_FORM_BELOW_AND_CLICK_THE__GET_PASSWORD__BUTTON_TO_HAVE_YOUR_CURRENT_PASSWORD_SENT_TO_YOUR_EMAIL_ADDRESS_ON_FILE_WITH_COMPAS_
            | translate
    }}
</p>
<div class="container-fluid pr-0 pl-0">
    <form
        [name]="form.name"
        #ngForm="ngForm"
    >
        <div class="row">
            <div class="col-12 col-sm-8 mr-auto ml-auto form-group">
                <label [for]="form.fields.EMAIL.id">{{
                    form.fields.EMAIL.label | translate
                }}</label>
                <input
                    type="text"
                    class="form-control"
                    [name]="form.fields.EMAIL.name"
                    [placeholder]="form.fields.EMAIL.placeholder | translate"
                    [disabled]="form.submitted"
                    [(ngModel)]="email"
                    [field]="form.fields.EMAIL"
                />
                <div
                    class="alert alert-warning mt-1 mb-0"
                    role="alert"
                    *ngIf="form.errors.EMAIL"
                >
                    {{ form.errors.EMAIL }}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-8 mr-auto ml-auto">
                <div
                    class="alert alert-info"
                    role="alert"
                    *ngIf="form.submitted"
                >
                    {{ i18n._928_PLEASE_WAIT_ | translate }}
                </div>
                <div
                    class="alert alert-warning"
                    role="alert"
                    *ngIf="failure"
                >
                    {{ form.serverError | translate }}
                </div>
                <div
                    class="alert alert-success"
                    role="alert"
                    *ngIf="success"
                >
                    {{
                        i18n._870_SUCCESS__CHECK_YOUR_EMAIL_FOR_A_PASSWORD_RESET_EMAIL_
                            | translate
                    }}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="float-right">
                    <ng-container *ngIf="!success; else successTpl">
                        <button
                            type="button"
                            class="btn btn-secondary mr-2"
                            (click)="_dialogRef.close()"
                        >
                            {{ i18n._121_CANCEL | translate }}
                        </button>
                        <button
                            type="submit"
                            class="btn btn-primary"
                            (click)="onSubmit()"
                            [disabled]="form.submitted"
                        >
                            {{ i18n._941_GET_PASSWORD | translate }}
                        </button>
                    </ng-container>
                    <ng-template #successTpl>
                        <button
                            type="button"
                            class="btn btn-primary"
                            (click)="_dialogRef.close()"
                        >
                            {{ i18n._763_CLOSE | translate }}
                        </button>
                    </ng-template>
                </div>
            </div>
        </div>
    </form>
</div>
